export { getPortalNameFromBranding } from './branding';
